export function createRealtimeEventBus<TEvent>() {
  type Listener = (event: TEvent) => void;
  const listeners = new Set<Listener>();

  return {
    publish(event: TEvent) {
      listeners.forEach((listener) => {
        listener(event);
      });
    },
    subscribe(listener: Listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
